import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14 13.333h-2V6a.667.667 0 0 0-.667-.667h-2V2a.667.667 0 0 0-.666-.667h-4A.667.667 0 0 0 4 2v11.333H2a.667.667 0 1 0 0 1.334h12a.666.666 0 1 0 0-1.334m-6 0H5.333V2.667H8zm2.667 0H9.333V6.667h1.334z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })